import { TabsProps } from '@material-ui/core/Tabs';

const MuiTabs: TabsProps = {
    indicatorColor: 'primary',
    textColor: 'secondary',
};

export default MuiTabs;
